import React, { useRef } from "react";
import Navbar from "../../components/Navbar";
import { Button, Form, Input, message } from "antd";
import { useNavigate, Link } from "react-router-dom";
import { loginUser } from "../../utils/api";
import { useLocalStorage } from "../../hooks";

const Landing = () => {
  const formRef = useRef();
  const [messageApi, contextHolder] = message.useMessage();
  const [accessToken, setAccessToken] = useLocalStorage("accessToken", null);
  const [refreshToken, setRefreshToken] = useLocalStorage("refreshToken", null);
  let navigate = useNavigate();

  const clearLocalStorage = () => {
    localStorage.clear();
    console.log("LocalStorage has been cleared!");
  };

  const onFinish = async (values) => {
    try {
      clearLocalStorage();
      const res = await loginUser(values);
      const data = res.data;
      if (data && data.success && data.data) {
        setAccessToken(data.data.access_token);
        setRefreshToken(data.data.refresh_token);
        window.location.replace(`${window.location.origin}/dashboard`);
      }
    } catch (err) {
      messageApi.open({
        type: "error",
        content:
          err?.response?.data?.detail || err?.response?.data?.message || "Internal Server Error !!! Please try again after sometime",
      });
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  // Breakpoints in this repo are MAX-width, the inverse of stock Tailwind (see
  // tailwind.config.js), so `lg:` means 1023px and below and `md:` means 767px
  // and below. Read every responsive class here that way.
  //
  // min-h-screen rather than h-screen: the illustration is tall, and a fixed
  // viewport height clipped the form on short windows instead of scrolling.
  return (
    <div id="landing" className="bg-primaryBlue min-h-screen flex flex-col">
      {contextHolder}
      <Navbar />
      <div className="flex flex-1 px-[40px] lg:flex-col lg:gap-10 lg:py-10 md:px-5 md:py-6">
        {/*
          The line below must say the same thing as the pre-hydration copy in
          index.html, which is what search crawlers read. scripts/verify-seo.sh
          compares the two source files, so they cannot drift apart unnoticed.
          The illustration is decorative, so its empty alt keeps it out of the
          accessibility tree.

          No order swap once stacked: a phone reads this column first, exactly
          as the desktop layout reads left to right. The illustration shrinks
          with the viewport instead of disappearing, small enough that the
          Submit button still lands above the fold on a short phone.
        */}
        <div className="w-1/2 flex flex-col justify-center items-center gap-4 px-4 lg:w-full lg:px-0">
          <p className="font-MuseoSans text-white text-base max-w-xl text-center">
            Phenobee is the crop analytics dashboard from Polybee.
          </p>
          {/*
            One breakpoint only, deliberately. Breakpoints here are max-width
            and Tailwind emits them in ascending order, so `max-width: 767px`
            lands BEFORE `max-width: 1023px` in the stylesheet. At phone width
            both match and the later, larger one wins, which means `md:` can
            never override `lg:` in this repo. Stacking two height steps
            silently gave phones the tablet size. Everything above 767px is
            handled by the viewport cap instead of a second breakpoint.
          */}
          <img
            src="/images/landing_page.svg"
            alt=""
            className="h-[600px] max-h-[45vh] w-auto md:h-[180px] md:max-h-none"
          />
        </div>
        {/*
          The page's only heading, and it names what the page is for. Without
          it a screen-reader user listing headings hears nothing, and the form
          they came to use has no landmark. Kept in step with index.html.
        */}
        <div className="w-1/2 flex flex-col justify-center items-center gap-6 lg:w-full">
          <h1 className="font-MuseoSans text-white text-2xl md:text-xl text-center">
            Sign in to Phenobee
          </h1>
          <Form
            ref={formRef}
            className="w-full max-w-[360px]"
            layout="vertical"
            name="basic"
            labelCol={{
              span: 10,
            }}
            wrapperCol={{
              span: 24,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <Form.Item
              label="Username"
              name="username"
              rules={[
                {
                  required: true,
                  message: "Please input your username!",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please input your password!",
                },
              ]}
            >
              <Input.Password />
            </Form.Item>

            <Form.Item className="w-full text-center">
              <Button
                type="primary"
                htmlType="submit"
                className="border-white bg-transparent"
              >
                Submit
              </Button>
            </Form.Item>

            <Link
              to="/forgot_password"
              className="mb-6 w-full flex justify-center"
            >
              <button className="cursor-pointer text-white text-xs ">
                Forgot Password?
              </button>
            </Link>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default Landing;
